module.exports = __webpack_public_path__ + "img/fruit.eea53c5e.svg";